import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios, { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";

// 📅 Always-visible service period line for the boss: trial / lifetime + maintenance / legacy yearly.
export default function PlanStatusBar() {
  const { user } = useAuth();
  const { lang } = useLang();
  const [d, setD] = useState(null);
  const isBoss = ["owner", "admin"].includes(user?.role);
  useEffect(() => {
    if (!isBoss || !user?.tenant_id) return;
    axios.get(`${API}/tenant/my-usage`).then(r => setD(r.data)).catch(() => {});
  }, [isBoss, user?.tenant_id]);
  if (!d) return null;
  const Z = (zh, es) => (lang === "zh" ? zh : es);
  const fmt = (s) => (s ? s.split("T")[0].split("-").reverse().join("/") : "—");
  let tone = "border-slate-700 bg-slate-800/60 text-slate-300", text = "", days = null, icon = "📅";
  if (d.is_trial) {
    days = d.trial_days_left; icon = "🧪";
    text = d.trial_expired ? Z(`试用已于 ${fmt(d.trial_expires_at)} 结束`, `Prueba terminó el ${fmt(d.trial_expires_at)}`) : Z(`试用期至 ${fmt(d.trial_expires_at)}`, `Prueba hasta el ${fmt(d.trial_expires_at)}`);
  } else if (d.lifetime_active) {
    days = d.maintenance_days_left; icon = "✅";
    text = Z(`已买断${d.activated_at ? `（${fmt(d.activated_at)} 开通）` : ""} · 维护服务 ${d.activated_at ? fmt(d.activated_at) + " → " : ""}${fmt(d.maintenance_expiry)}`,
             `Licencia vitalicia${d.activated_at ? ` (activada ${fmt(d.activated_at)})` : ""} · Mantenimiento ${d.activated_at ? fmt(d.activated_at) + " → " : ""}${fmt(d.maintenance_expiry)}`);
  } else if (d.subscription_expiry) {
    days = d.subscription_days_left;
    text = Z(`订阅有效期至 ${fmt(d.subscription_expiry)}`, `Suscripción vigente hasta ${fmt(d.subscription_expiry)}`);
  } else return null;
  if (typeof days === "number") {
    if (days < 0) tone = "border-red-500/40 bg-red-500/10 text-red-200";
    else if (days <= 30) tone = "border-amber-500/40 bg-amber-500/10 text-amber-200";
    else tone = "border-emerald-500/30 bg-emerald-500/5 text-emerald-200";
  }
  const daysTxt = typeof days === "number" ? (days < 0 ? Z(`已过期 ${-days} 天`, `vencido hace ${-days} días`) : Z(`剩 ${days} 天`, `faltan ${days} días`)) : "";
  return (
    <div className={`flex items-center justify-between gap-2 rounded-lg border px-3 py-1.5 mb-3 text-xs ${tone}`} data-testid="plan-status-bar">
      <span className="truncate">{icon} {text}{daysTxt ? ` · ${daysTxt}` : ""}</span>
      <Link to="/admin/ai-credits" className="shrink-0 underline font-semibold hover:opacity-80" data-testid="plan-status-renew">
        {d.is_trial ? Z("开通正式版 →", "Activar →") : d.lifetime_active ? Z("续维护费 →", "Renovar mantenimiento →") : Z("续费 →", "Renovar →")}
      </Link>
    </div>
  );
}
